import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { getCookie } from "./components/getcookie";
import { Container, Row, Col, Toast, } from "react-bootstrap";
import dock_logo from "./assets/svg/dock_logo.svg";
function PreLanding() {
   const adminApiUrl = process.env.REACT_APP_ADMIN_API_URL;
   const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;

  const navigate = useNavigate();

  useEffect(() => {
    const fetchData = async () => {
      try {
          const response = await axios.get(adminApiUrl+"get_role_permission/9", {
                     params: { },
                     headers: {
                         'Content-Type': 'application/json; charset=UTF-8',
                         "Accept": "application/json",      
                         "Access-Control-Allow-Origin": "*", // Required for CORS support to work
                          "Authorization":getCookie("mawalog")
                       }
                   }).then((response) => {
                     if(response.status===200){
                        navigate('/dashboard/default');
                     }
                   }).catch((error) => {
                     if (error.response) {
                       console.error("Error Status:", error.response.status);
                       console.error("Error Data:", error.response.data);
                       if(error.response.status===401){ 
                         document.cookie = 'redirectPath=' + window.location.href + '; path=/; domain=.mawalog.com';
                         document.cookie = 'mawalog=; path=/; domain=.mawalog.com';
                         window.location.href = accountsUrl;
                         }
                     } else {
                       console.error("Request failed:", error.message);
                     }
                   });;
       /*  const res = await axios.get('/api/check');
        if (res.data.success) {
          navigate('/landing'); // go to landing if successful
        } else {
          navigate('/error'); // or redirect to error/fallback
        } */
      } catch (error) {
        console.error(error);
       /*  navigate('/error'); */
       document.cookie = 'redirectPath=' + window.location.href + '; path=/; domain=.mawalog.com';
       document.cookie = 'mawalog=; path=/; domain=.mawalog.com';
       window.location.href = accountsUrl;
      }
    };

    fetchData();
  }, [navigate]);

  return <Container fluid style={{ width: '100vw',height: '100vh', display: 'flex',alignItems:'center',justifyContent:'center', background:'#ffffff', paddingLeft: '0px', paddingRight: '0px' }}>
   <img src={dock_logo} alt="Dock Icon"  width={'500px'}/>
  
   </Container>;
}

export default PreLanding;
